module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.0934dd19.png";